import React from 'react';

function SelectInput({id, label, defaultOption, values, onChange}) {
  return (
    <div>
      <div className='flex'>
        <label for={id} class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
        <label className='text-red-500'> *</label>
      </div>
      <select id={id} onChange={onChange} 
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option selected>{defaultOption}</option>
        {values.length > 0 ? (
          values.map((item) => {
            return (
              <option value={item.value}>{item.value}</option>
            )
          })
        ) : null }
      </select>
    </div>
  );
}

export default SelectInput;

